import styled from 'styled-components'
import { RopFormWrap } from 'src/styles/styledcomponent/views/RopForm/RopForm'
import PageCalling from 'src/components/common/PageCalling'
import { useParams } from 'react-router-dom'
import { PramsKeys } from 'src/types/type'
import useAPI from 'src/hooks/useAPI'
import { useRecoilState, useSetRecoilState } from 'recoil'
import {
  authKeyState,
  PartnerListData,
  TelTypeState,
  TermsListData,
  uiData,
} from 'src/recoil/common'
import useMoveScroll from 'src/hooks/useMoveScroll'
import { useEffect } from 'react'
import Banner from 'src/components/common/Banner'
import MVNOModal from 'src/components/common/MVNOModal'
import useIsImgLoad from 'src/hooks/useIsImgLoad'
import PhoneVerification from 'src/components/views/Rop01/PhoneVerification'
import Terms from 'src/components/views/Rop01/Terms'
import JoinSubmit from 'src/components/views/Rop01/JoinSubmit'
import Footer from 'src/components/views/Rop01/Footer'
import useSubmit from 'src/hooks/useSubmit'
import FooterBanner from "src/components/common/FooterBanner";
import { convertTermsData } from 'src/service/join'
import VulnerableCheckModal from 'src/components/common/VulnerableCheckModal'

const Rop03Wrap = styled(RopFormWrap)``

const Rop03 = () => {
  const { pcode, authKey, telecom } = useParams<PramsKeys>()
  const submit = useSubmit(pcode ?? '')
  const termsApi = useAPI('requestTermsList')

  const setTermsListData = useSetRecoilState(TermsListData)
  const setPartnerData = useSetRecoilState(PartnerListData)
  const setTelType = useSetRecoilState(TelTypeState)
  const setAuthKey = useSetRecoilState(authKeyState)
  const [
    {
      layoutsInsert: { mainBg },
    },
    setUiData,
  ] = useRecoilState(uiData)

  const {
    data: getTermsData,
    isSuccess,
    isLoading: getLoading,
  } = termsApi?.useSetQuery({ PCode: pcode })

  // 2024-06-26 이미지 로딩 작업
  const { isImgLoad, banner1Ref, banner2Ref } = useIsImgLoad(isSuccess)
  const { onMoveToElement, RefInput } = useMoveScroll(banner2Ref)

  const checkImgLoad = () => {
    if (pcode !== 'cokbank_01') return true
    else if (pcode === 'cokbank_01' && isImgLoad) return true
    else return false
  }

  const isErrorPartner = getTermsData?.Header.ErrCode === 1011

  useEffect(() => {
    if (isSuccess && !isErrorPartner) {
      const data = getTermsData?.Body
      setTermsListData(convertTermsData(data))
      setPartnerData(data?.Partner)
      setUiData(JSON.parse(atob(data.Partner.UiData)))
      setTelType(Number(telecom))
    }
    // eslint-disable-next-line
  }, [isSuccess, getTermsData?.Partner, getTermsData?.Body?.Terms, setPartnerData, setTermsListData])

  useEffect(() => {
    if (isSuccess) {
      if (pcode === 'pinc_01') {
        setAuthKey(authKey)
      }
    }
  }, [isSuccess, authKey, pcode, setAuthKey])

  return (
    <Rop03Wrap mainBg={mainBg}>
      <PageCalling active={getLoading || !checkImgLoad()} />
      {isSuccess && (
        <>
          <Banner banner1Ref={banner1Ref} banner2Ref={banner2Ref} />
          {checkImgLoad() && (
            <>
              <PhoneVerification
                onMoveToElement={onMoveToElement}
                RefInput={RefInput}
                submit={submit}
              />
              { !isErrorPartner && <Terms /> }
              <JoinSubmit submit={submit} />
              <FooterBanner />
              <Footer />
            </>
          )}
        </>
      )}
      {submit.isOpen && <MVNOModal submit={submit} />}
      {submit.vulnerableModal.isOpen && <VulnerableCheckModal submit={submit} />}
    </Rop03Wrap>
  )
}
export default Rop03
